import { BiDotsVerticalRounded } from "react-icons/bi";
import ContextMenu from "./ContextMenu";
import OutsideAlerter from "@shared/Components/Utils/OutsideAlerter";

interface Ellipsis {
	className?: string;
	children: JSX.Element | JSX.Element[];
	isShowing: boolean;
	setIsShowing: React.Dispatch<React.SetStateAction<boolean>>;
	isContextOpen: boolean;
	setIsContextOpen: React.Dispatch<React.SetStateAction<boolean>>;
	contextMenuSide: string;
}

export default function ReusableEllipsis(props: Ellipsis) {
	function handleOnClick(e: React.MouseEvent) {
		e.stopPropagation();
		props.setIsContextOpen((prevState) => !prevState);
	}

	function clickedOutside() {
		props.setIsContextOpen(false);
		// props.setIsShowing(false);
	}

	return (
		<>
			{props.isShowing &&
				<OutsideAlerter onClick={clickedOutside} className="absolute right-3">
					<div
						className={" flex items-center rounded ellipsis " + props.className}
						onClick={handleOnClick}
					>
						<BiDotsVerticalRounded size={22} />
					</div>

					{props.isContextOpen &&
						<ContextMenu setIsContextOpen={props.setIsContextOpen} contextMenuSide={props.contextMenuSide}>
							{props.children}
						</ContextMenu>}
				</OutsideAlerter>}
		</>
	);
}
